import React, { useState } from "react";

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

const ModalAddModel = ({ isOpen, onClose, onSave, isEmbedded = false }) => {
  const [name, setName] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Funkcja resetująca dane formularza
  const resetForm = () => {
    setName("");
    setManufacturer("");
    setDescription("");
  };

  // Funkcja obsługująca anulowanie
  const handleCancel = () => {
    resetForm();
    onClose();
  };

  const handleSave = async () => {
    if (!name) {
      alert("Name is required");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/models/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          manufacturer,
          description,
        }),
      });

      if (!response.ok) {
        throw new Error(`Błąd: ${response.status}`);
      }

      const savedModel = await response.json();
      console.log("Nowy model zapisany:", savedModel);
      resetForm();
      onSave(savedModel.id);
      onClose();
    } catch (error) {
      console.error("Błąd podczas zapisywania modelu:", error.message);
      alert("Nie udało się zapisać modelu. Spróbuj ponownie.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  // Zawartość formularza
  const formContent = (
    <div className="flex flex-col">
      <h3 className="text-lg font-semibold mb-4">Add Model</h3>
      <div>
        <label className="block text-sm font-medium text-graphite-700">Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4"
          placeholder="Name"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-graphite-700">Manufacturer</label>
        <input
          type="text"
          value={manufacturer}
          onChange={(e) => setManufacturer(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4"
          placeholder="Manufacturer"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-graphite-700">Description</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4"
          placeholder="Description"
          rows="3"
        ></textarea>
      </div>
      <div className="flex justify-end space-x-2">
        <button
          onClick={handleCancel}
          className="px-4 py-2 border border-steel-300 text-graphite-700 font-medium rounded-full hover:bg-steel-100 flex items-center text-sm whitespace-nowrap"
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 border border-brand-500 bg-brand-500 font-medium text-white rounded-full hover:bg-brand-600 flex items-center text-sm whitespace-nowrap"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );

  // Tryb osadzony (dla sidebaru)
  if (isEmbedded) {
    return <div className="bg-white">{formContent}</div>;
  }

  // Tryb popup
  return (
    <div className="fixed inset-0 bg-graphite-950/50 flex justify-center items-center z-80">
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative">
        <button
          onClick={handleCancel}
          className="absolute top-4 right-4 text-graphite-500 hover:text-graphite-900"
        >
          ✕
        </button>
        {formContent}
      </div>
    </div>
  );
};

export default ModalAddModel;